var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect, useRef } from 'react';
export const useIsMounted = () => {
    _react_refresh_temp_1();
    const mounted = useRef(false);
    useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);
    return mounted;
};
_react_refresh_temp_1(useIsMounted, "K6RcWNPnAJ1smoz1e676pCSIO08=");
